import { safeCall } from '@xemplo/safe-call';

const expiredCookieAttributes = '; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';

function getCookieDeletionDomains(host: string) {
  const hostParts = host.split('.').filter(Boolean);

  return hostParts
    .map((_, index) => hostParts.slice(index).join('.'))
    .filter((domain) => domain.includes('.'));
}

function getHostName(host?: string) {
  if (host) return host;
  if (typeof window === 'undefined') return null;

  return window.location.hostname;
}

function clearCookieForDomain(cookieName: string, domain: string) {
  document.cookie = `${cookieName}=${expiredCookieAttributes}; domain=${domain}`;
  document.cookie = `${cookieName}=${expiredCookieAttributes}; domain=.${domain}`;
}

function clearHostOnlyCookie(cookieName: string) {
  document.cookie = `${cookieName}=${expiredCookieAttributes}`;
}

function clearSessionCookieUnsafe(cookieName: string, host?: string) {
  if (typeof document === 'undefined') return;

  clearHostOnlyCookie(cookieName);

  const hostName = getHostName(host);
  if (!hostName) return;

  getCookieDeletionDomains(hostName).forEach((domain) => {
    clearCookieForDomain(cookieName, domain);
  });
}

export function clearSessionCookie(cookieName: string, host?: string) {
  safeCall(() => clearSessionCookieUnsafe(cookieName, host));
}
